import styled from "styled-components";

export const BanSurface = styled.div`
	min-width: 0; color: #344054; font: 13px/1.5 system-ui, sans-serif;
	input, textarea { min-width: 0; width: 100%; }
	textarea { min-height: 72px; }
	label { display: flex; flex-direction: column; gap: 4px; min-width: 0; font-size: 12px; color: #667085; }
	button:disabled { cursor: default; }
	fieldset { min-width: 0; border: 0; margin: 0; padding: 0; }
	.buttons { display: flex; flex-wrap: wrap; align-items: center; gap: 6px; }
	.grid { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 12px; }
	.full { grid-column: 1 / -1; }
	.hint { margin: 4px 0 0; font-size: 12px; color: #667085; }
	.ban-status { padding: 12px; margin-bottom: 16px; border: 1px solid #e4e9ef; border-radius: 8px; background: #f8fafc; }
	.ban-status button { display: inline-flex; align-items: center; justify-content: center; min-height: 36px; padding: 7px 11px; border: 1px solid #dce3ec; border-radius: 7px; background: #fff; color: #344054; font: inherit; cursor: pointer; }
	.ban-status button.danger { color: #b42342; border-color: #ebc7cf; }
	.ban-status-head, .ban-status-row { display: flex; align-items: flex-start; justify-content: space-between; gap: 12px; }
	.ban-status-head { align-items: center; }
	.ban-status-row { padding-top: 12px; margin-top: 12px; border-top: 1px solid #e4e9ef; }
	.ban-status-row > div { min-width: 0; overflow-wrap: anywhere; }
	.ban-status-row small { display: block; color: #667085; }
	.ban-status p { margin: 8px 0 0; }
	.error { margin: 12px 0 0; color: #b42342; overflow-wrap: anywhere; }
	.notice { padding: 10px 16px; color: #18774d; border-bottom: 1px solid #edf0f5; }
	.modal-actions { display: flex; justify-content: flex-end; flex-wrap: wrap; gap: 8px; margin-top: 18px; }
	.summary { margin: 0 0 16px; padding: 12px; border: 1px solid #e4e9ef; border-radius: 8px; background: #f8fafc; }
	.summary strong { display: block; overflow-wrap: anywhere; }
	dl { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 12px 18px; margin: 0; }
	dl > div { min-width: 0; }
	dt { color: #667085; font-size: 12px; margin-bottom: 4px; }
	dd { margin: 0; overflow-wrap: anywhere; white-space: pre-wrap; font-variant-numeric: tabular-nums; }
	details { margin-top: 16px; }
	summary { cursor: pointer; color: #667085; font-size: 12px; }
	pre { margin: 10px 0 0; white-space: pre-wrap; overflow-wrap: anywhere; font: 12px/1.5 ui-monospace, monospace; }
	@media (max-width: 540px) { .grid, dl { grid-template-columns: minmax(0, 1fr); } }
`;

export const BanListPanel = styled(BanSurface)`
	margin-top: 16px; border: 1px solid #e1e6ef; border-radius: 12px; background: #fff;
	.filter-form { padding: 12px 16px; border-bottom: 1px solid #edf0f5; }
	.filter-row { display: flex; flex-wrap: wrap; align-items: flex-end; gap: 10px; }
	.filter-row > label { flex: 0 1 150px; }
	.filter-row > .search { flex: 1 1 200px; max-width: 360px; }
	.advanced { margin-top: 12px; padding-top: 12px; border-top: 1px solid #edf0f5; }
	.advanced .grid { grid-template-columns: repeat(auto-fit, minmax(min(100%, 160px), 1fr)); }
	.toolbar, footer { display: flex; justify-content: space-between; flex-wrap: wrap; align-items: center; gap: 12px; padding: 12px 16px; }
	h3 { margin: 0; font-size: 14px; font-weight: 600; }
	.state { text-align: center; padding: 30px 16px; color: #667085; }
	.state.error { color: #b42342; margin: 0; }
	.table-scroll { overflow-x: auto; max-width: 100%; }
	table { width: 100%; min-width: 850px; border-collapse: collapse; text-align: left; }
	th, td { padding: 10px 14px; border-bottom: 1px solid #edf0f5; vertical-align: top; }
	th { background: #f8fafc; font-weight: 500; font-size: 12px; color: #667085; white-space: nowrap; }
	td { max-width: 280px; overflow-wrap: anywhere; font-variant-numeric: tabular-nums; }
	td small { display: block; color: #667085; margin-top: 3px; font-size: 11px; }
	.nowrap { white-space: nowrap; }
	tbody tr:hover { background: #fafbfc; }
	.reason { max-width: 260px; display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden; }
	footer label { flex-direction: row; align-items: center; }
	footer select { width: auto; }
	.pages { display: flex; align-items: center; gap: 10px; }
`;
